import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const routes = [

  {
    path: "/index",
    component: () => import("@/views/index"),
    meta: {
      title: "index",
    },
  },
  {
    path: "/order-flow",
    component: () => import("@/views/order-flow"),
    meta: {
      title: "order-flow",
    },
  },
  {
    path: "/*",
    redirect: '/index',
    meta: {
      title: "index",
    },
  },
];
const router = new Router({
  scrollBehavior: () => ({ y: 0 }),
  mode: 'history',
  base: '/',
  routes,
});

export default router;
